export default function isStaging() {
  return window.location.host.startsWith('lessonize-staging.');
}
